import { Middleware } from "@reduxjs/toolkit";
import { baseApi } from "@/services/base.service";
import { SetFormPagamentoValues } from "../slices/sheet.slice";
import { SetEventoId } from "../slices/eventos.slice";

// Constantes para localStorage
const EVENTO_ID_KEY = "EventoId";

export const eventoModeMiddleware: Middleware =
  (store) => (next) => (action) => {
    const prevMode = store.getState().eventoMode.eventoMode;

    // Executa a action primeiro
    const result = next(action);

    const newMode = store.getState().eventoMode.eventoMode;

    /** Ao entrar no modo igreja: evita CentroCustoId/MeioPagamentoId de evento no sheet e força listas gerais frescas no Financeiro. */
    if (
      newMode === "igreja" &&
      prevMode !== "igreja" &&
      typeof window !== "undefined" &&
      window.location.href.includes("sistema")
    ) {
      store.dispatch(SetFormPagamentoValues(null));
      store.dispatch(
        baseApi.util.invalidateTags([
          { type: "CentroCustosGeral", id: "LIST" },
          { type: "FormasPagamentoGeral", id: "LIST" },
          { type: "LancamentosGeral" },
          { type: "TotaisLancamentosGeral" },
          { type: "ResumoFinanceiroGeral" },
        ]),
      );
    }

    // Verifica o valor atual do eventoMode no estado
    const currentMode = newMode;
    const currentEventoId = store.getState().eventosReducer.EventoId;

    // Só executa se o modo for "liderancas" E se houver um evento selecionado
    if (
      currentMode === "liderancas" &&
      currentEventoId !== null &&
      window.location.href.includes("sistema")
    ) {
      // Limpa o localStorage para EventoId
      if (typeof window !== "undefined") {
        localStorage.removeItem(EVENTO_ID_KEY);
      }

      // Dispatch da action para limpar o eventId no store
      store.dispatch(SetEventoId(null));
    }

    return result;
  };
